import {AfterViewInit, Component, ElementRef, inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NavigationEnd, Router, Event} from '@angular/router';
import {Route} from './shared/services/routing-helper.service';
import {PlansService} from "./plans/plans.service";
import {delay, filter} from "rxjs";
import {LoaderService} from "./shared/services/loader.service";
import {environment} from "../environments/environment";
import {DataLayerService} from "./shared/services/data-layer.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild('loaderContainer', {static: true})
  loaderContainer!: ElementRef<HTMLDivElement>;

  title = 'prever-checkout-planos-webapp';
  isResumeRoute: boolean = false;

  private _router = inject(Router);
  private _routes = Route;
  private _planService = inject(PlansService);
  private _loaderService = inject(LoaderService);
  private _renderer = inject(Renderer2);
  private _dataLayerService = inject(DataLayerService);
  private _titleService = inject(Title);

  ngOnInit() {
    this._loaderService.setLoaderElement(this.loaderContainer.nativeElement);
    this._planService.getPlanParamsFromUrl();

    if (environment.production) {
      this.loadBlipChat();
      this.addGTMToHead();
      this.addGTMNoScript();
    }
  }

  ngAfterViewInit() {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      delay(0)
    ).subscribe(() => {
      this.checkRoute();
      this.onRouteChange();
    });
  }

  onRouteChange() {
    this._dataLayerService.genericSendDatalayer('pageview_virtual', {
      title: this._titleService.getTitle(),
      url: window.location.href
    });
  }

  addGTMToHead(): void {
    const script = this._renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MS7DN2RG');
  `;

    const  scriptWindowDataLayer= this._renderer.createElement('script');
    scriptWindowDataLayer.type = 'text/javascript';
    scriptWindowDataLayer.text = `window.dataLayer = window.dataLayer || [];`;


    this._renderer.appendChild(document.head, scriptWindowDataLayer);
    this._renderer.appendChild(document.head, script);
  }

  addGTMNoScript(): void {
    const noscript = this._renderer.createElement('noscript');
    noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MS7DN2RG"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;

    this._renderer.insertBefore(document.body, noscript, document.body.firstChild);
  }

  checkRoute() {
    this.isResumeRoute = this._router.url === `/${this._routes.Resume.path}`;
  }

  loadBlipChat(): void {

    const script = this._renderer.createElement('script');
    script.src = 'https://unpkg.com/blip-chat-widget';
    script.type = 'text/javascript';
    script.onload = () => this.initBlipChat();
    this._renderer.appendChild(document.body, script);
  }

  initBlipChat(): void {
    new (window as any).BlipChat()
      .withAppKey('c2lzdGVtYXByZXZlcnJvdXRlcm9maWNpYWw6ZTQ0NGZhYzYtZDRhNy00YjYxLThlNDgtNjFlYzI5NGZlMjM2')
      .withButton({
        color: '#442578',
        icon: 'https://blipmediastore.blob.core.windows.net/public-medias/Media_ca46a885-8603-42df-943b-c2d3374a9bea'
      })
      .withCustomCommonUrl('https://sistemaprever.chat.blip.ai/')
      .build();
  }

}
